export default "__VITE_ASSET__c3080095__"